import { Button, Skeleton, DatePicker, Card, Spin, ConfigProvider } from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
  formatDateTime,
  generatedISOFormatDateString,
} from "../../../../../../Utils/DateConverstion";
import CustomDrawer from "../../../../../Elements/CustomDrawer";
import CustomSelect from "../../../../../Elements/CustomSelect";
// import TreeSelectCustomWithSelectAll from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
import TreeSelectCustom from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustom";
import { useSelector } from "react-redux";
import { useStoreUpdaterWithAPI } from "../../../../../../Hooks/UseStoreUpdaterWithApi";
import { APIConstants } from "../../../../../../Common/APIConstants";
import * as echarts from 'echarts';
import * as XLSX from "xlsx";
import SteamTreeSelectCustom from "../../../../../Elements/TreeSelect/TreeSelectCustom";
import {
  FilterOutlined,
   } from "@ant-design/icons";
import Empty from "../../../../../CommonScreens/Empty";
const { RangePicker } = DatePicker;
import dayjs from "dayjs";
const MAX_DAYS = 90;
import weekday from "dayjs/plugin/weekday";
import weekOfYear from "dayjs/plugin/weekOfYear";
import customParseFormat from "dayjs/plugin/customParseFormat";
// import TreeSelectCustomWithSelectAll from "../../../../../Elements/TreeSelect/TreeSelectCustomWithSelectAll";
    import ExcelJS from 'exceljs';
import { saveAs } from 'file-saver';
import minnotra_logo from "../../../../../../Assets/Images/logo2.png";
import SteamTreeSelectCustomWithSelectAll from "../../LiveModule/LiveTrends/LineChart/TreeSelectCustomWithAllSelect";
// Extend plugins
dayjs.extend(weekday);
dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);
 
const ElectricalHistoricalTrends = () => {
  const chartRef = useRef(null);  
  const {loading,  makeRequest } = useStoreUpdaterWithAPI();
  const [sectionId, setSectionId] = useState(1);
  const [converterGroupId, setConverterGroupId] = useState(1);
  const [selectedMeterIds, setSelectedMeterIds] = useState([]); 
  const [selectedValues, setSelectedValues] = useState(["KWT"]);
  const [skip, setSkip] = useState(true);
  const [open, setOpen] = useState(false); 
  // const [fromDateObj, setFromDateObj] = useState(null);
  // const [fromDateString, setFromDateString] = useState();
  // const [toDateObj, setToDateObj] = useState(null);
  // const [toDateString, setToDateString] = useState(); 
  const [chartSkip, setChartSkip] = useState(true);
 const [fromDateObj, setFromDateObj] = useState(dayjs().subtract(1, "hour").format("YYYY-MM-DD HH:mm:ss"));
    const [fromDateString, setFromDateString] = useState(dayjs().subtract(1, "hour").format("YYYY-MM-DD HH:mm:ss"));
    const [toDateObj, setToDateObj] = useState(dayjs().format("YYYY-MM-DD HH:mm:ss"));
    const [toDateString, setToDateString] = useState(dayjs().format("YYYY-MM-DD HH:mm:ss"));
   const [value, setValue] = useState([dayjs().subtract(1, "hour"), dayjs(),]);
  const [sectionError, setSectionError] = useState();
  const [converterError, setConverterError] = useState();
  const [meterError, setMeterError] = useState();
  const [paraError, setParaError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [chartLoading, setChartLoading] = useState(false);
  const [flowSectionResData, setflowSectionResData] = useState([]);
  const [getFlowConverterResData, setgetFlowConverterResData] = useState([]);
  const [flowGroupDetailsResData, setflowGroupDetailsResData] = useState([]);
  const [nsGetFlowConverterResData, setnsGetFlowConverterResData] = useState([]);
  const [getFlowSteamGroupMeterResData, setgetFlowSteamGroupMeterResData] = useState([]);
  const [showCalendar, setShowCalendar] = useState(false);
  // const [value, setValue] = useState([null,null]);
  const [datesError, setDatesError] = useState(null);
  const [steamHistoricalData,setsteamHistoricalData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [parameter,setParameter]=useState([]);
  const [data1,setData1]= useState([]);
  const [data2,setData2]= useState([]);
  const [data3,setData3]= useState([]);
  const [parameterLenght, setParameterLenght] = useState('')
  const [legends,setLegends]= useState([])
  const defaultParameters = ['kWhImport','KWT','IAVG','VLLAvg'];
    const [excelFromDate,setExcelFromDate]=useState()
    const [excelToDate,setExcelToDate]=useState()
  const [loadings, setLoadings] = useState(true);
    const [defaultLoad,setDefaultLoad]=  useState(true)
        const [excelImage, setExcelImage] = useState(null);
       const loggedIn = useSelector((state) => state.user);
      // console.log(loggedIn)
      useEffect(()=>{
    
        setExcelImage(loggedIn?.images?.excelImage?`data:image/png;base64,${loggedIn?.images?.excelImage}`:null);
      },[loggedIn])
  const simulateLoading = (setLoadings) => {
    setLoadings(true);
    setTimeout(() => {
      setLoadings(false);
    }, 2000); // 2 seconds
  };
  useEffect(()=>{
    simulateLoading(setLoadings);
  },[])


  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;
  const color = useSelector((state) => state.ThemeChange);
  // //console.log(color)
   useEffect(() => {
      document.documentElement.style.setProperty("--date-ok-btn", color.themeConfig.colorPrimary);
      document.documentElement.style.setProperty("--date-now-btn", "#fff");
    }, [color]);

  useEffect(()=>{
    makeRequest({ 
        type: APIConstants.GET, 
        url: `${APIConstants.GET_FLOW_SECTION_MASTER_DETAILS}`
      }).then((res) => {
        // //console.log(res)
        if(res&&res.length>0){
          
          setflowSectionResData(res);
        }
      });

      makeRequest({  
        type: APIConstants.GET, 
        url: `${APIConstants.ELECTRICAL_PARAMETER_DETAILS}`
      }).then((res) => {
        // //console.log(res)
        if(res&&res.length>0){
          
          setParameter(res);
        }
      });
   
  },[])
  useEffect(()=>{
 
    if(sectionId==1){
      makeRequest({ 
          type: APIConstants.GET, 
          url: `${APIConstants.GET_ELECTRICAL_CONVERTER_DETAILS}`
        }).then((res) => {
          // //console.log(res)
          if(res&&res.length>0){
            
            setgetFlowConverterResData(res);
          }
        });

    }
    if(sectionId==2){
      makeRequest({  
         type: APIConstants.POST,
         url: `${APIConstants.ELECTRICAL_GROUP_NAME}?Module=1`
        }).then((res) => {
          // //console.log(res)
          if(res&&res.length>0){
            setflowGroupDetailsResData(res);
          }
        });

    }

   
   
  },[sectionId])

  useEffect(()=>{
    if(converterGroupId&&sectionId==1){
      makeRequest({ 
          type: APIConstants.GET,  
          url: `${APIConstants.ELECTRICAL_METERS_DETAILS}?ConverterID=${converterGroupId}` 
        }).then((res) => {
          // //console.log(res) 
          if(res&&res.length>0){
            if (defaultLoad) {
            const firstFiveMeters = res
              .slice(0, 5)
              .map((meter) => meter.meterid);

            //console.log(res.map((meter) => meter.meterid));
            //console.log(firstFiveMeters);
            setSelectedMeterIds(firstFiveMeters);
            localStorage.setItem("PlotMeterIds", firstFiveMeters);
            setDefaultLoad(false);
          }
            setnsGetFlowConverterResData(res);
          }
        });

    }
    if(converterGroupId&&sectionId==2){
      makeRequest({ 
          type: APIConstants.POST,  
          url: `${APIConstants.ELECTRICAL_GROUP_METER_DETAILS}?GroupID=${converterGroupId}&Module=1`
        }).then((res) => {
          // //console.log(res)
          if(res&&res.length>0){
            setgetFlowSteamGroupMeterResData(res);
          }
        });
    }
  },[converterGroupId])
 
  
  function transformDatas(inputData) {
    // Initialize arrays to store unique CreatedOn values and unique meter names
    const createdOn = [];
    const meterNames = [];
    
    // Collect unique CreatedOn values and meter names
    inputData.forEach(entry => {
      const formattedDate = entry.CreatedOn.replace("T", " ");
      if (!createdOn.includes(formattedDate)) {
        createdOn.push(formattedDate);
      }
      if (!meterNames.includes(entry.METERNAME)) {
        meterNames.push(entry.METERNAME);
      }
    });
  
    // Initialize series array with meter names
    const series = meterNames.map(meterName => ({
      name: meterName,
      type: 'line',
      stack: 'Total',
      data: Array(createdOn.length).fill(0) // Initialize with zeros for each CreatedOn value
    }));
  
    inputData.forEach(entry => {
      const formattedDate = entry.CreatedOn.replace("T", " ");
      const dateIndex = createdOn.indexOf(formattedDate);
      const meterIndex = meterNames.indexOf(entry.METERNAME);
  
      if (dateIndex !== -1 && meterIndex !== -1) {
        series[meterIndex].data[dateIndex] += entry.KWHTotal;
      }
    });
  
    // Return the formatted structure
    return { series, createdOn, meterNames };
  }
  

function prepareLineChartDatas(data,toDate,fromDate, excludeFields = ["SiteName", "MeterId", "CreatedOn", "METERNAME"]) {
  const series = [];
  const xAxisData = [];
  const metrics = {};
  const parameters=[];
  
  function removeDuplicates(inputArray) {
    // //console.log(inputArray)
    const seen = new Set();
    const result = [];
    
    inputArray.forEach(item => {
      if (!seen.has(item)) {
        result.push(item); 
        seen.add(item);
      }
    });
     
    return result;
  }

  data.forEach((entry) => {
      // Add unique timestamps to x-axis  
      if (!xAxisData.includes(entry.CreatedOn.replace("T", " "))) {
          xAxisData.push(entry.CreatedOn.replace("T", " ")); 
      }

      // Iterate through all fields in the entry
      for (const key in entry) {
          if (!excludeFields.includes(key)) {
              // Group by METERNAME and metric (e.g., KWHTotal)
              const metricKey = `${entry.METERNAME}-${key}`;
              if (!metrics[metricKey]) {
                  metrics[metricKey] = [];
              }
              metrics[metricKey].push(entry[key]);
              parameters.push(key);

          }
      }
  });

  // Prepare series for ECharts
  for (const [metricName, values] of Object.entries(metrics)) {
      series.push({
          name: metricName,
          type: 'line',
          data: values, 
      });
  }
  const para = removeDuplicates(parameters);
  // //console.log(para);
  // //console.log(xAxisData);
  const uniqueTimestamps = Array.from(
    new Set(xAxisData.map(ts => {
      const [date, time] = ts.split(' '); // Split date and time
      const timeWithoutSeconds = time.split(':').slice(0, 2).join(':'); // Keep hour and minute
      return `${date} ${timeWithoutSeconds}:00`; // Append :00 for seconds
    }))
  );

  // //console.log(uniqueTimestamps)
  // Return the chart configuration

  return {
      xAxisData:uniqueTimestamps,
      series: series,
      parameter:para
  };
}

function prepareLineChartData19(
  data,
  toDate,
  fromDate,
  excludeFields = ["SiteName", "MeterId", "CreatedOn", "METERNAME"]
) {
  const series = [];
  const metrics = {};
  const parameters = [];

  // Ensure valid date string (pad month/day if needed)
  const normalizeDateString = (str) => {
    const parts = str.split("T");
    const [y, m, d] = parts[0].split("-");
    const paddedDate = `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    return `${paddedDate}T${parts[1]}`;
  };

  const start = new Date(normalizeDateString(fromDate));
  const end = new Date(normalizeDateString(toDate));

  console.log("FromDate Parsed:", start);
  console.log("ToDate Parsed:", end);

  // Helper for timestamp format
  const formatTs = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const mi = String(date.getMinutes()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:00`;
  };

  // Generate all timestamps
  const allTimestamps = [];
  let current = new Date(start);
  while (current <= end) {
    allTimestamps.push(formatTs(current));
    current.setMinutes(current.getMinutes() + 1);
  }
  console.log("Generated timestamps:", allTimestamps);

  // Process data
  data?.forEach((entry) => {
    const createdOn = new Date(entry.CreatedOn);
    console.log("Entry CreatedOn parsed:", createdOn);

    if (createdOn >= start && createdOn <= end) {
      const formattedTs = formatTs(createdOn);
      console.log("Using timestamp:", formattedTs);

      for (const key in entry) {
        if (!excludeFields.includes(key)) {
          const metricKey = `${entry.METERNAME}-${key}`;
          if (!metrics[metricKey]) {
            metrics[metricKey] = {};
          }
          metrics[metricKey][formattedTs] = entry[key];
          parameters.push(key);
        }
      }
    }
  });
  console.log("Metrics after processing:", metrics);

  // Build series
  for (const [metricName, valuesByTs] of Object.entries(metrics)) {
    const filledValues = allTimestamps.map(
      (ts) => valuesByTs[ts] ?? ''
    );
    series.push({
      name: metricName,
      type: "line",
      data: filledValues,
    });
  }

  console.log("Final series:", series);

  return {
    xAxisData: allTimestamps,
    series,
    parameter: [...new Set(parameters)],
  };
}

function prepareLineChartData(
  data,
  toDate,
  fromDate,
  excludeFields = ["SiteName", "MeterId", "CreatedOn", "METERNAME"]
) {
  const series = [];
  const metrics = {};
  const parameters = [];

  // Normalize date string
  const normalizeDateString = (str) => {
    const parts = str.split("T");
    const [y, m, d] = parts[0].split("-");
    const paddedDate = `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`;
    return `${paddedDate}T${parts[1]}`;
  };

  const start = new Date(normalizeDateString(fromDate));
  const end = new Date(normalizeDateString(toDate));

  // Format timestamp (yyyy-mm-dd hh:mm:00)
  const formatTs = (date) => {
    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const hh = String(date.getHours()).padStart(2, "0");
    const mi = String(date.getMinutes()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd} ${hh}:${mi}:00`;
  };

  // Generate all timestamps
  const allTimestamps = [];
  let current = new Date(start);
  while (current <= end) {
    allTimestamps.push(formatTs(current));
    current.setMinutes(current.getMinutes() + 1);
  }

  // If data is empty, just return timestamps (no series)
  if (!data || data.length === 0) {
    return {
      xAxisData: allTimestamps,
      series: [],        // ✅ no fake series
      parameter: [],
    };
  }

  // Process available data
  data.forEach((entry) => {
    const createdOn = new Date(entry.CreatedOn);
    if (createdOn >= start && createdOn <= end) {
      const formattedTs = formatTs(createdOn);
      for (const key in entry) {
        if (!excludeFields.includes(key)) {
          const metricKey = `${entry.METERNAME}-${key}`;
          if (!metrics[metricKey]) {
            metrics[metricKey] = {};
          }
          metrics[metricKey][formattedTs] = entry[key];
          parameters.push(key);
        }
      }
    }
  });

  // Build chart series
  for (const [metricName, valuesByTs] of Object.entries(metrics)) {
    const filledValues = allTimestamps.map(
      (ts) => valuesByTs[ts] ?? ""
    );
    series.push({
      name: metricName,
      type: "line",
      data: filledValues,
    });
  }

  return {
    xAxisData: allTimestamps,
    series,
    parameter: [...new Set(parameters)],
  };
}


  
  const getResponse =(inputData)=>{
    console.log(inputData);
    setIsLoading(true);
    if(inputData&&inputData.SectionID&&inputData.ConverterorGroupID&&inputData.Parameters&&inputData.MeterIds?.length>0){
      makeRequest({ 
          type: APIConstants.GET,  
          url: `${APIConstants.ELECTRICAL_HISTORICAL_REPORT}?SectionID=${inputData.SectionID}&ConverterorGroupID=${inputData.ConverterorGroupID}&MeterIds=${inputData.MeterIds}&Parameters=${inputData.Parameters}&FromDate=${inputData.FromDate}&Todate=${inputData.ToDate}` 
        }).then((res) => {
          console.log(res)
          setsteamHistoricalData(res);
          // if (res&&res.length>1) {     
            // const data = transformDatas(res);
            // //console.log(data)
            // //console.log(data.meterNames)
            // setData1(data.createdOn) 
            // setData2(data.series)
            // setData3(data.meterNames)
            const test =prepareLineChartData(res,inputData.ToDate.replace(".000Z",""),inputData.FromDate.replace(".000Z",""))
            console.log(test) 
            console.log(test.series)
            // console.log(test.series.pop()) 
            setData1(test.xAxisData)
            setData2(test.series)
            // setData3(test.parameter)
          // }
          setIsLoading(false);
        });

    }
  }
 
  const getFlowSectionList = (flowSectionResData && flowSectionResData) || [];
  const getFlowConverterList =
    (getFlowConverterResData && getFlowConverterResData) || [];
  const flowGroupDetailsList =
    (flowGroupDetailsResData && flowGroupDetailsResData) || [];
  const nsGetFlowConverterList =
    (nsGetFlowConverterResData && nsGetFlowConverterResData) || [];
  const getFlowSteamGroupMeterList =
    (getFlowSteamGroupMeterResData && getFlowSteamGroupMeterResData) || [];

  const showDrawer = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  useEffect(() => {
    // After 1 second, set skipValue to false
    const timeoutId = setTimeout(() => {
      setSkip(false);
    }, 3000);

    // Clear the timeout if the component unmounts or skipValue is set to false
    return () => clearTimeout(timeoutId);
  }, []);

  const handleChangeSection = (changedValues) => {
    setSectionId(changedValues);
    setConverterGroupId()
    setSelectedMeterIds();
    if (changedValues) {
      setSectionError("");
    }
  };

  const handleChangeConverterGroup = (changedValues) => {
    setConverterGroupId(changedValues);
    setSelectedMeterIds();
    if (changedValues) {
      setConverterError("");
    }
  };

  const handleMeterChange = (selectedValues) => {
    setSelectedMeterIds(selectedValues);
    if (selectedValues) {
      setMeterError("");
    }
  };

  const handleTreeChange = (values) => {
    setSelectedValues(values);
    if (values.length>4) {
      // //console.log(values);
      setParameterLenght('Cannot select more than 4 values');
    }else{
      setParameterLenght('');
    }
    if (values) {
      setParaError("");
    }
  };

  const setChartInputData = () => {
    const ids = selectedMeterIds?.map((id) => id).join(",");
    const para = selectedValues?.map((id) => id).join(",");
    // //console.log(para)

    const fromDate = new Date(fromDateString || new Date());
    const toDate = new Date(toDateString || new Date());

    const formattedFromDate = generatedISOFormatDateString(fromDate);
    const formattedToDate = generatedISOFormatDateString(toDate);
    setExcelFromDate(formatDateTime(formattedFromDate))
    setExcelToDate(formatDateTime(formattedToDate))

    sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
                console.log(para)
                console.log(selectedMeterIds)
                console.log(nsGetFlowConverterList)
                console.log(getFlowSteamGroupMeterList)

const paramArr = para.split(',');

// Build legends
const legendsData = selectedMeterIds.flatMap(id => {
  const meter = sectionId === 1
                ? nsGetFlowConverterList.find(m => m.meterid === id)
                : getFlowSteamGroupMeterList.find(m => m.meterid === id);
  return meter ? paramArr.map(p => `${meter.metername}-${p}`) : [];
});

console.log(legendsData);
// console.log(legendsData.pop());
setLegends(legendsData)


    const inputData = {
      SectionID: Number(sectionId) || 1,
      ConverterorGroupID: Number(converterGroupId) || 1,
      Parameters:para||0,
      MeterIds: ids || 0,
      FromDate: formattedFromDate,
      ToDate: formattedToDate,
    };
    // //console.log(inputData)
    getResponse(inputData);
  };

  useEffect(() => {
    setChartInputData();
  },[defaultLoad]);
 
  useEffect(() => {
    setChartSkip(!chartSkip);
    updateChart();
  },[steamHistoricalData]);
 
  const validateInput = (value, label) => {
    const error = !value ? `Please Select ${label}` : "";
    return error;
  };

  const handleSubmit = () => {
    const sectionError = validateInput(sectionId, "Section");
    const converterError = validateInput(converterGroupId, "Converter");
    const meterError = validateInput(selectedMeterIds?.length, "Meter");
    const paraError = validateInput(selectedValues?.length, "Parameter");
    const fromDateError = validateInput(fromDateString, "From Date");
    const toDateError = validateInput(toDateString, "To Date");
    if(fromDateError||toDateError){
      setDatesError('Please select a date range')
    }

    setSectionError(sectionError); 
    setConverterError(converterError);
    setMeterError(meterError);
    setParaError(paraError);
    setFromDateError(fromDateError);
    setToDateError(toDateError);

    if (
      !sectionError &&
      !converterError &&
      !meterError &&
      !paraError 
      &&
      !fromDateError &&
      !toDateError&&!datesError 
      // && !parameterLenght
    ) {
      onClose();
      setChartLoading(true);
      setChartInputData();
      
      setIsLoading(true); 
    }
  };

  const onChangeFromDate = ( dateString) => {
    setFromDateString(dateString);
    setFromDateObj(dateString);
    if (dateString) {
      setFromDateError("");
    }
  };

  const onChangeToDate = ( dateString) => {
    setToDateString(dateString);
    setToDateObj(dateString);
    if (dateString) {
      setToDateError("");
    }
  };

  const updateChart = async () => { 
    try {
      setChartLoading(true);
  
      // Filter steamHistoricalData based on selected meter IDs
      const selectedMeterData = steamHistoricalData?.filter((item) =>
        selectedMeterIds?.map((id) => Number(id)).includes(item?.meterId)
      );
  
      // Transform the data in a chart series format
      const transformData = (parameterName, meterName) => {
        const data = selectedMeterData
          ?.filter((item) => item?.sitename === meterName)
          ?.map((item) => item[parameterName]);
        return {
          name: `${parameterName}-${meterName}`,
          data,
        };
      };
  
      const seriesData = [];
      // //console.log(selectedValues)
      // //console.log(nsGetFlowConverterList)
  
      // Iterate over selected meter IDs and selectedValues properties
      selectedMeterIds?.forEach((id) => {
        const meterName = sectionId === 1
          ? nsGetFlowConverterList?.find((item) => item?.meterid === Number(id))?.metername
          : getFlowSteamGroupMeterList?.find((item) => item?.meterID === Number(id))?.meterName;
          // //console.log(meterName)
  
        selectedValues.forEach(({ parametername }) => {
          seriesData.push(transformData(parametername, meterName));
        });
      });

      // //console.log(selectedValues)
      // //console.log(seriesData)
  
      const datesArray = [];
      const dateProperty = "createdOn";
      
      selectedMeterIds?.forEach((id) => {
        const meterName = sectionId === 1
          ? nsGetFlowConverterList?.find((item) => item?.meterid === Number(id))?.metername
          : getFlowSteamGroupMeterList?.find((item) => item?.meterID === Number(id))?.meterName;
          
        datesArray.push(transformData(dateProperty, meterName));
      });
  
      // Filter to include only selected parameter names in selectedValues
      const finalData = seriesData.filter((series) => 
        selectedValues.some(({ parametername }) => series.name.includes(parametername))
      );
  
      // Find the longest date array and reverse it
      const reversedDate = datesArray.reduce((largest, current) => {
        if (!largest || current.data.length > largest.data.length) {
          return { ...current, data: [...current.data].reverse() };
        }
        return largest;
      }, null);
  
      const reversedFinalData = finalData.map((data) => ({
        data: data.data.reverse(),
        name: data.name,
      }));
  
      // Format dates for x-axis
      const localDateTime = reversedDate?.data?.map((date) =>
        new Date(date).toLocaleString("en-US")
      );
      // //console.log(reversedFinalData)
  
      // setData1(reversedFinalData);
      // setData2(localDateTime);
  
      setChartLoading(false);
    } catch (err) {
      //console.error(err);
      setChartLoading(false);
    }
  };

// const exportToExcel = (data) => {
//   if (!Array.isArray(data) || data.length === 0) return;

//   // Get the maximum data length among all series
//   const maxRows = Math.max(...data.map(item => item.data.length));

//   // Header row: ["S. No.", "DG Incomer", "SolarOutput", ...]
//   const headers = ["S. No.", ...data.map(item => item.name)];

//   // Build the rows dynamically, allowing for different data lengths
//   const rows = Array.from({ length: maxRows }, (_, i) => {
//     const row = [`${i + 1}`];
//     for (const item of data) {
//       row.push(item.data[i] !== undefined ? item.data[i] : ""); // Handle missing values
//     }
//     return row;
//   });

//   const excelData = [headers, ...rows];

//   // Create a new workbook and worksheet
//   const workbook = XLSX.utils.book_new();
//   const worksheet = XLSX.utils.aoa_to_sheet(excelData);

//   // Append the worksheet to the workbook
//   XLSX.utils.book_append_sheet(workbook, worksheet, "EnergyData");

//   // Generate a filename with timestamp
//   const now = new Date();
//   const timestamp = now.toLocaleString("en-GB", {
//     year: "numeric",
//     month: "2-digit",
//     day: "2-digit",
//     hour: "2-digit",
//     minute: "2-digit",
//     second: "2-digit"
//   }).replace(/[/,: ]/g, "-");

//   const filename = `Historical_Trends_${timestamp}.xlsx`;

//   // Export the file
//   XLSX.writeFile(workbook, filename);
// };
  
    // useEffect(() => {
    //   if (selectedValues.length === 0) {
    //     setSelectedValues(defaultParameters); 
    //   }
    // }, [selectedValues]);



const getImageBufferFromUrl = async (url) => {
  const response = await fetch(url);
  return await response.arrayBuffer();
};

const exportToExcels = async (data2, data1, excelFromDate, excelToDate) => {
  const xAxisData = data1;

  if (!Array.isArray(xAxisData) || !Array.isArray(data2) || xAxisData.length === 0) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Energy Data");

  // 🖼 Add Logo
  worksheet.mergeCells("A1:B2");
  const logoBuffer = await excelImage? getImageBufferFromUrl(excelImage):getImageBufferFromUrl(minnotra_logo); // make sure minnotra_logo is defined
  const imageId = workbook.addImage({
    buffer: logoBuffer,
    extension: "png",
  });
  worksheet.addImage(imageId, {
    tl: { col: 0.2, row: 0.2 },
    ext: { width: 100, height: 40 },
  });

  //  Title Row ("Historical Trends")
  worksheet.mergeCells("C1:F2"); // adjust merge as needed based on number of columns
  const titleCell = worksheet.getCell("C1");
  titleCell.value = "Historical Trends";
  titleCell.font = { size: 16, bold: true };
  titleCell.alignment = { vertical: "middle", horizontal: "center" };

  //  Date Range Row
  worksheet.mergeCells("A3:B3");
  const fromDateCell = worksheet.getCell("A3");
  fromDateCell.value = `From: ${excelFromDate}`;
  fromDateCell.font = { bold: true };
  fromDateCell.alignment = { vertical: "middle", horizontal: "left" };

  worksheet.mergeCells("C3:D3");
  const toDateCell = worksheet.getCell("C3");
  toDateCell.value = `To: ${excelToDate}`;
  toDateCell.font = { bold: true };
  toDateCell.alignment = { vertical: "middle", horizontal: "left" };

  const startRow = 5; // ⬅️ shifted down because of logo/title/date

  // 🟩 Header Row
  const headers = ["Date", ...data2.map((item) => item.name)];
  const headerRow = worksheet.getRow(startRow);
  headerRow.values = headers;
  headerRow.height = 22;
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF00B050" },
    };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // 📊 Data Rows
  const totals = Array(data2.length).fill(0);

  xAxisData.forEach((timestamp, i) => {
    const rowData = [timestamp];

    for (let j = 0; j < data2.length; j++) {
      const value = data2[j]?.data?.[i];
      const val = typeof value === "number" ? value : parseFloat(value) || 0;
      if (!isNaN(val)) totals[j] += val;
      rowData.push(value !== undefined ? val : "");
    }

    const row = worksheet.getRow(startRow + 1 + i);
    row.values = rowData;
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // 🔢 Totals Row
  const totalRowIndex = startRow + 1 + xAxisData.length;
  const totalRow = worksheet.getRow(totalRowIndex);
  totalRow.values = ["Total", ...totals.map((t) => Math.round(t * 100) / 100)];
  totalRow.font = { bold: true };
  totalRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD9EAD3" },
    };
    cell.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // 📏 Auto column width
  worksheet.columns.forEach((col) => {
    let maxLength = 0;
    col.eachCell({ includeEmpty: true }, (cell) => {
      const val = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, val.length);
    });
    col.width = maxLength < 12 ? 12 : maxLength + 2;
  });

  // 📂 Export with Timestamped Filename
  const now = new Date();
  const timestamp = now
    .toLocaleString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
    .replace(/[/,: ]/g, "-");

  const filename = `Historical_trends_${timestamp}.xlsx`;
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), filename);
};
const exportToExcel = async (data2, data1, excelFromDate, excelToDate) => {
  const xAxisData = data1;

  if (!Array.isArray(xAxisData) || !Array.isArray(data2) || xAxisData.length === 0) return;

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Energy Data");

  // 🖼 Add Logo (Row 1-2)
  worksheet.mergeCells("A1:B2");
  const logoBuffer = await (excelImage
    ? getImageBufferFromUrl(excelImage)
    : getImageBufferFromUrl(minnotra_logo)); // fallback logo
  const imageId = workbook.addImage({
    buffer: logoBuffer,
    extension: "png",
  });
  worksheet.addImage(imageId, {
    tl: { col: 0.1, row: 0.1 },
    ext: { width: 100, height: 38 },
  });

  // 📌 Title Row ("Historical Trends") → Row 3-4
  worksheet.mergeCells("A3:F4"); // merged across full width (A-F)
  const titleCell = worksheet.getCell("A3");
  titleCell.value = "Historical Trends";
  titleCell.font = { size: 16, bold: true };
  titleCell.alignment = { vertical: "middle", horizontal: "center" };

  // 📅 Date Range Row → Row 5
  worksheet.mergeCells("A5:B5");
  const fromDateCell = worksheet.getCell("A5");
  fromDateCell.value = `From: ${excelFromDate}`;
  fromDateCell.font = { bold: true };
  fromDateCell.alignment = { vertical: "middle", horizontal: "left" };

  worksheet.mergeCells("C5:D5");
  const toDateCell = worksheet.getCell("C5");
  toDateCell.value = `To: ${excelToDate}`;
  toDateCell.font = { bold: true };
  toDateCell.alignment = { vertical: "middle", horizontal: "left" };

  const startRow = 7; // ⬅️ Table starts here now

  // 🟩 Header Row
  const headers = ["Date", ...data2.map((item) => item.name)];
  const headerRow = worksheet.getRow(startRow);
  headerRow.values = headers;
  headerRow.height = 22;
  headerRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FF00B050" },
    };
    cell.font = { bold: true, color: { argb: "FFFFFFFF" } };
    cell.alignment = { vertical: "middle", horizontal: "center" };
    cell.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // 📊 Data Rows
  const totals = Array(data2.length).fill(0);

  xAxisData.forEach((timestamp, i) => {
    const rowData = [timestamp];

    for (let j = 0; j < data2.length; j++) {
      const value = data2[j]?.data?.[i];
      const val = typeof value === "number" ? value : parseFloat(value) || 0;
      if (!isNaN(val)) totals[j] += val;
      rowData.push(value !== undefined ? val : "");
    }

    const row = worksheet.getRow(startRow + 1 + i);
    row.values = rowData;
    row.eachCell((cell) => {
      cell.border = {
        top: { style: "thin" },
        bottom: { style: "thin" },
        left: { style: "thin" },
        right: { style: "thin" },
      };
    });
  });

  // 🔢 Totals Row
  const totalRowIndex = startRow + 1 + xAxisData.length;
  const totalRow = worksheet.getRow(totalRowIndex);
  totalRow.values = ["Total", ...totals.map((t) => Math.round(t * 100) / 100)];
  totalRow.font = { bold: true };
  totalRow.eachCell((cell) => {
    cell.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFD9EAD3" },
    };
    cell.border = {
      top: { style: "thin" },
      bottom: { style: "thin" },
      left: { style: "thin" },
      right: { style: "thin" },
    };
  });

  // 📏 Auto column width
  worksheet.columns.forEach((col) => {
    let maxLength = 0;
    col.eachCell({ includeEmpty: true }, (cell) => {
      const val = cell.value ? cell.value.toString() : "";
      maxLength = Math.max(maxLength, val.length);
    });
    col.width = maxLength < 12 ? 12 : maxLength + 2;
  });

  // 📂 Export with Timestamped Filename
  const now = new Date();
  const timestamp = now
    .toLocaleString("en-GB", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    })
    .replace(/[/,: ]/g, "-");

  const filename = `Historical_trends_${timestamp}.xlsx`;
  const buffer = await workbook.xlsx.writeBuffer();
  saveAs(new Blob([buffer]), filename);
};



  useEffect(() => {
    if (loading || !data1 || !data2) return; // Prevent chart rendering if loading or data is unavailable
  
    console.log(data1);
    console.log(data2);
  
    const myChart = echarts.init(chartRef.current);
  
    const option = { 
      // backgroundColor: isdarkMode ? '#2d3748' : '#ECFDF3', 
      backgroundColor: isdarkMode ? '#2d3748' :"#fff",

      // title: {
      //   text: `Historical Trends`,
      //   left: 'center',
      //   top: '5px',
      //   textStyle: {
      //     color: isdarkMode ? 'white' : 'black',
      //   },
      // },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow',
        },
        confine: true, 
        position: function (point, params, dom, rect, size) {
          // `point` is the mouse position, `[x, y]`
          // `size` contains the size of the tooltip
          const [x, y] = point;
          const { contentSize, viewSize } = size; // Size of the tooltip and view
      
          let xPos = x + 10; // Add some padding
          let yPos = y + 10;
      
          // Prevent overflow on the right
          if (xPos + contentSize[0] > viewSize[0]) {
            xPos -= contentSize[0] + 20; // Move it left
          }
      
          // Prevent overflow on the bottom
          if (yPos + contentSize[1] > viewSize[1]) {
            yPos -= contentSize[1] + 1000; // Move it up
          }
      
          return [xPos, yPos];
        },
      },
      
      legend: {
        bottom: '0px',
        textStyle: {
          color: isdarkMode ? 'white' : 'black',
        },
      },
      grid: {
        left: '3%',
        right: '4%',
        bottom: '25%', 
        containLabel: true,
      },
      toolbox: {
        show: true,
        orient: 'horizontal',
        left: 'right',
        top: 'top',
        feature: {
          myExport: {
            show: true,
            title: "Export to Excel",
            icon: "path://M5 0L15 10L5 20Z", 
            onclick: () => {
              exportToExcel(data2,data1,excelFromDate,excelToDate);
            },
          },
          mark: { show: true },
          magicType: { show: true, type: ['line', 'bar'] },
          saveAsImage: { show: true },
        },
        iconStyle: {
          borderColor: isdarkMode ? 'white' : 'black',
        },
        emphasis: {
          iconStyle: {
            borderColor: isdarkMode ? '#FFD700' : '#1E90FF', 
          },
        },
      },
      xAxis: [
        {
          type: 'category',
          data: Array.from({ length: 8 }, (_, i) => `S. No.${i + 1}`), // Example categories
          axisTick: { show: false },
          data: data1,
          axisLabel: {
            color: isdarkMode ? 'white' : 'black',
            fontSize: '10',
            fontWeight: 'bold',
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          axisLabel: {
            color: isdarkMode ? 'white' : 'black',
            fontSize: '10',
            fontWeight: 'bold',
          },
        },
      ],
      // series: data2,
      series: legends.map(meter => {
  const found = data2.find(s => s.name === meter);
  return found ? found : { name: meter, type: "bar", data: [] };
}),
      dataZoom: [
        {
          type: 'inside', // Enables zooming via scroll or pinch
          start: 0,
          end: 100,
        },
      ],
    };
    
  
    myChart.setOption(option);
  
    const resizeHandler = () => myChart.resize();
    window.addEventListener('resize', resizeHandler);
  
    return () => {
      window.removeEventListener('resize', resizeHandler);
      myChart.dispose();
    };
  }, [data1, data2, isdarkMode, loading,color]); 
  
 

  const today = dayjs();
  const startOfWeek = dayjs().startOf("week").startOf("day"); // Sunday 12:00 AM
  const endOfWeek = dayjs().endOf("week").startOf("day");     // Saturday 12:00 AM
  
  const startOfLastWeek = dayjs().subtract(1, "week").startOf("week").startOf("day"); // Previous Sunday 12:00 AM
  const endOfLastWeek = dayjs().subtract(1, "week").endOf("week").startOf("day");     // Previous Saturday 12:00 AM
  
  const startOfMonth = dayjs().startOf("month").startOf("day");     // 1st of this month 12:00 AM
  const endOfMonth = dayjs().endOf("month").startOf("day");         // Last of this month 12:00 AM
  
  const startOfLastMonth = dayjs().subtract(1, "month").startOf("month").startOf("day");
  const endOfLastMonth = dayjs().subtract(1, "month").endOf("month").startOf("day");
  
  const rangePresets = [
    { label: "Yesterday", value: [today.subtract(1, "day").startOf("day"), today.startOf("day")] },
    { label: "This Week", value: [startOfWeek, endOfWeek] },
    { label: "Last Week", value: [startOfLastWeek, endOfLastWeek] },
    { label: "This Month", value: [startOfMonth, endOfMonth] },
    { label: "Last Month", value: [startOfLastMonth, endOfLastMonth] },
    { label: "Last 7 Days", value: [dayjs().subtract(7, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 15 Days", value: [dayjs().subtract(15, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 30 Days", value: [dayjs().subtract(30, "day").startOf("day"), today.startOf("day")] },
    { label: "Last 90 Days", value: [dayjs().subtract(90, "day").startOf("day"), today.startOf("day")] },
  ];
  
    const handleDateChange = (value) => {
    // if (!value) return;
    // const diff = value[1]?.diff(value[0], "day");

    // if (diff > MAX_DAYS) {
    //   alert("Date range cannot exceed 90 days");
    //   return;
    // }

    if (value) {
      // const fromDate = value[0];
      // const toDate = value[1];
      const fromDate = value[0]?.format("YYYY-MM-DD HH:mm:ss");
      const toDate = value[1]?.format("YYYY-MM-DD HH:mm:ss");
      if(!fromDate&& !toDate){
        setDatesError('Please select a date range');
      }else{
        setDatesError(null)
      }

      // //console.log([fromDate, toDate]);
      setValue([value[0], value[1]]);
      onChangeFromDate(fromDate);
      onChangeToDate(toDate);
    } else {
      setDatesError('Please select a date range');
    }
  };
  //   //console.log("data1", data1);
  // //console.log(data2)
  // //console.log(loading)
  // //console.log(datesError)

  return (
    <div id="chart" className={` relative bg-white p-4 rounded-md  dark ${isdarkMode ? 'darkmode' : 'whitemode '} `}>

       <div className="flex justify-between items-center px-0 pb-4">
        <div className="text-3xl">
          <p
            className={` dark ${isdarkMode ? "darkfont" : "whitemode"} text-center pb-0  ml-0 font-[500] tracking-[1px]`}
          >
            HISTORICAL TRENDS 
          </p>
        </div>
          <Button
            role="primary"
            size="large"
            className="flex justify-center items-center secondary-btn"
          style={{ "--secondary-color": color.themeConfig.secondaryColor,"--primary-color": color.themeConfig.colorPrimary }}
            onClick={() => setOpen(!open)}
          >
            <FilterOutlined /> Filter
          </Button>
      </div>
     
      <Card 
        className={`p-4 rounded-md dark ${isdarkMode ? "darkmode" : "whitemode "} w-full lg:w-full md:w-11/12 sm:w-10/12 xs:w-11/12`}
        // style={{ position: "relative", overflow: "hidden", background:isdarkMode ? "" : color.themeConfig.colorPrimaryShade }}
      >  
{
          data1.length ===0 && !loading&&!loadings &&
          <Empty open={open}  setOpen={setOpen} isdarkMode={isdarkMode} />
          // <div className="text-3xl">
          // <div className={`${!isdarkMode ? "text-black" : "text-white"}`}>No Data Available</div>
          // </div> 
         } 
          {loading  && ( 
      <>
        <Skeleton active paragraph={{ rows: 6 }} />
      </> 
      )}
        <div ref={chartRef} className={`${(!loading||!loadings) && data1.length>0 ? 'min-h-[80vh]':'h-0'}  w-[100%]  mx-auto rounded-lg  mb-0 md:mb-0 px-3`}/>

        </Card>


        
      <CustomDrawer
        title="Close"
        showDrawer={showDrawer}
        open={open}
        onClose={onClose}
      >
        <div className="flex flex-col space-y-2">
          <CustomSelect
            label="Section:"
            options={getFlowSectionList}
            onSelect={handleChangeSection}
            valueKey="sectionID"
            nameKey="sectionName"
            selectedValues={sectionId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {sectionError}
          </small>
          <CustomSelect
            label="Converter / Group:"
            options={
              sectionId === 1 ? getFlowConverterList : flowGroupDetailsList
            }
            onSelect={handleChangeConverterGroup}
            valueKey={sectionId === 1 ? "siteID" : "groupID"}
            nameKey={sectionId === 1 ? "siteName" : "department"}
              selectedValues={converterGroupId}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {converterError}
          </small>
          <SteamTreeSelectCustomWithSelectAll
            label="Meters:"
            data={
              sectionId === 1
                ? nsGetFlowConverterList
                : getFlowSteamGroupMeterList
            }
            idKey={sectionId === 1 ? "meterid" : "meterid"}
            valueKey={sectionId === 1 ? "meterid" : "meterid"}
            nameKey={sectionId === 1 ? "metername" : "metername"}
            selectedValues={selectedMeterIds}
            setSelectedValues={setSelectedMeterIds}
            onSelect={handleMeterChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {meterError}
          </small>
          <TreeSelectCustom
            label="Parameters:"
            data={parameter}
            idKey="id"        
            nameKey="name"     
            valueKey="name" 
            // <SteamTreeSelectCustom
            // label="Parameters:"
            // data={parameter}
            // idKey="parameterid"
            // nameKey="parametername"
            // valueKey="parameterid"
            selectedValues={selectedValues}
            onSelect={handleTreeChange}
          />
          <small className="text-red-500 font-bold ml-[150px]">
            {paraError}
            {/* {parameterLenght} */}
          </small>
          <div className="mt-2 flex">
            <label className="pr-3 w-32 text-left">Date:</label>
            <RangePicker
      value={value}
      onChange={handleDateChange}
      popupClassName="custom-picker"
      presets={rangePresets}
      format="YYYY-MM-DD HH:mm:ss"
      showTime={{ format: "HH:mm:ss" }}
      className={`w-80 ml-0 shadow-lg rounded-3xl  ${
        isdarkMode
          ? "customRangePicker-dark  text-white"
          : "customRangePicker-light text-black"
      }`}
      panelRender={(originalPanel) => {
        if (!showCalendar) {
          return (
            <div
              className={`${
                isdarkMode ? "bg-[#1a1a1a]" : "bg-white"
              } flex flex-col gap-1 p-2 w-44 rounded`}
            >
              {rangePresets.map((preset) => (
                <div
                  key={preset.label}
                  onClick={() => handleDateChange(preset.value)}
                  className={`cursor-pointer px-2 py-1 rounded ${
                    isdarkMode
                      ? "text-white hover:bg-gray-700"
                      : "text-black hover:bg-gray-200"
                  }`}
                >
                  {preset.label}
                </div>
              ))}
              <button
                onClick={() => setShowCalendar(true)}
                className={`mt-2 px-2 py-1 rounded  border text-center ${
                  isdarkMode
                    ? "bg-[#1a1a1a] border-white text-white hover:bg-gray-700"
                    : "bg-white border-black text-black hover:bg-gray-200"
                }`}
              >
                Custom Dates
              </button>
            </div>
          );
        }
        return originalPanel;
      }}
      onOpenChange={(open) => {
        if (!open) setShowCalendar(false);
      }}
    />
    
      
          </div>  
              <small className="text-red-500 font-bold flex flex-col ml-[150px]">
            {datesError}
          </small>      
        </div>
        <div className="flex justify-center mt-4">
                      <Button
                        type= {isdarkMode? "":'primary'}
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        Search
                      </Button>
        </div>
      </CustomDrawer>
      <style>
        {`
          .custom-picker .ant-picker-ok .ant-btn{
            background-color: var(--date-ok-btn) !important;
            border-color: var(--date-ok-btn) !important;
            color: white !important;
          }
          .custom-picker .ant-picker-ok .ant-btn:hover {
            background-color: var(--date-ok-btn) !important;
            border-color: #d9363e !important;
          }
          .custom-picker .ant-picker-now .ant-picker-now-btn {
            color: var(--date-ok-btn) !important;
          }
          .custom-picker .anticon-swap-right, .anticon-calendar{
            // background-color: red !important;
            color: var(--date-ok-btn) !important;
          }
        `}
      </style>
    </div>
  );
};

export default ElectricalHistoricalTrends;
